export default {
  methods: {
    LS_storageSaveItem(name, value) {
      localStorage.setItem(name, JSON.stringify(value))
    },
    LS_storageRestoreItem(name, defaultValue) {
      let collapsedRows = localStorage.getItem(name)
      try {
        collapsedRows = JSON.parse(collapsedRows)
      } catch (e) {
        collapsedRows = defaultValue
        throw e
      }

      return collapsedRows
    }
  }
}
